import styled from 'styled-components';
import { Title } from 'Workspace/components/WorkspaceHeader/styles';

export const ProjectTitleWrapper = styled(Title)`
  font-size: 32px;
  line-height: 43px;
  white-space: initial;
`;
